export default "__VITE_ASSET__BxGrurAt__"